import { EThemePreference } from "@frontend-shared/types";
import type { LucideIcon } from "lucide-react";
import { Monitor, Moon, Sun } from "lucide-react";

export interface IThemeOption {
  value: EThemePreference;
  key: "system" | "auto" | "light" | "dark";
  icon: LucideIcon;
}

// NOTE: NSAI-5822 — one list for the header picker, the preferences screen and
// the admin preferences: all three write the same per-account preference and
// would otherwise disagree on what is offerable. `key` doubles as the
// `common:theme.*` label key.
//
// `auto` (NSAI-5650 — a fixed 19:00-07:00 clock schedule) is deliberately NOT
// offered: with `system` beside it, two "decide for me" answers that disagree
// about what decides are more choice than the control can explain in a menu.
// EThemePreference.AUTO is left in place and ThemeProvider still resolves it,
// so an account that stored it before keeps the behaviour it chose until it
// picks something else — see THEME_LABEL_KEY_BY_PREFERENCE for how those
// accounts are still labelled.
export const THEME_OPTIONS = [
  { value: EThemePreference.SYSTEM, key: "system", icon: Monitor },
  { value: EThemePreference.LIGHT, key: "light", icon: Sun },
  { value: EThemePreference.DARK, key: "dark", icon: Moon },
] as const satisfies readonly IThemeOption[];

// NOTE: Every preference that can be STORED, including the retired `auto`, so a
// control can name the current setting even when it is no longer offerable.
export const THEME_LABEL_KEY_BY_PREFERENCE: Record<
  EThemePreference,
  IThemeOption["key"]
> = {
  [EThemePreference.SYSTEM]: "system",
  [EThemePreference.AUTO]: "auto",
  [EThemePreference.LIGHT]: "light",
  [EThemePreference.DARK]: "dark",
};
